"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobTargetSourceValidator = void 0;
const class_validator_1 = require("class-validator");
let JobTargetSourceValidator = class JobTargetSourceValidator {
    validate(values, args) {
        const uniqueValues = new Set();
        for (const value of values) {
            const jobTypeCreationSource = value.substring(0, value.lastIndexOf('='));
            if (uniqueValues.has(jobTypeCreationSource)) {
                return false;
            }
            uniqueValues.add(jobTypeCreationSource);
        }
        return true;
    }
    defaultMessage(args) {
        return 'Duplicated target statuses are not allowed!';
    }
};
JobTargetSourceValidator = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: 'JobTargetSourceValidator', async: false })
], JobTargetSourceValidator);
exports.JobTargetSourceValidator = JobTargetSourceValidator;
//# sourceMappingURL=opportunityOptionJobTargetValidator.js.map